export default defineNuxtPlugin((nuxtApp) => {
  const {data, status} = useAuth();

  nuxtApp.hook('apollo:auth', ({token}) => {
    if (data.value?.accessToken) {
      token.value = data.value.accessToken;
    }
  });

  const {client} = useApolloClient();

  // Clear cache after unauthentication
  watch(status, (status) => {
    if (status === 'unauthenticated') {
      nextTick(() => client.cache.reset());
    }
  });
});
